export const MeshGradientAssetsBottom = {
  BlueGreenTealHigh: "/images/meshGradients/Size=High,Colour=Blue-Green-Teal.svg",
  TealGreenHigh: "/images/meshGradients/Size=High,Colour=Teal-Green.svg",
  OrangePinkHigh: "/images/meshGradients/Size=High,Colour=Orange-Pink.svg",
  PinkBlueTealHigh: "/images/meshGradients/Size=High,Colour=Pink-Blue-Teal.svg",
  PinkPurpleGreenHigh: "/images/meshGradients/Size=High,Colour=Pink-Purple-Green.svg",
  RedGreenTealHigh: "/images/meshGradients/Size=High,Colour=Red-Green-Teal.svg",
  BlueGreenTealLow: "/images/meshGradients/Size=Low,Colour=Blue-Green-Teal.svg",
  TealGreenLow: "/images/meshGradients/Size=Low,Colour=Teal-Green.svg",
  OrangePinkLow: "/images/meshGradients/Size=Low,Colour=Orange-Pink.svg",
  PinkBlueTealLow: "/images/meshGradients/Size=Low,Colour=Pink-Blue-Teal.svg",
  PinkPurpleGreenLow: "/images/meshGradients/Size=Low,Colour=Pink-Purple-Green.svg",
  RedGreenTealLow: "/images/meshGradients/Size=Low,Colour=Red-Green-Teal.svg",
  LightGoldLow: "/images/meshGradients/Size=Low,Colour=Light-Gold.svg",
  StrongGoldLow: "/images/meshGradients/Size=Low,Colour=Strong-Gold.svg",
}

export const MeshGradientAssetsRight = {
  BlueGreenTealHigh: "/images/meshGradients/Pos=Right,Size=High,Colour=Blue-Green-Teal.svg",
  TealGreenHigh: "/images/meshGradients/Pos=Right,Size=High,Colour=Teal-Green.svg",
  OrangePinkHigh: "/images/meshGradients/Pos=Right,Size=High,Colour=Orange-Pink.svg",
  PinkBlueTealHigh: "/images/meshGradients/Pos=Right,Size=High,Colour=Pink-Blue-Teal.svg",
  PinkPurpleGreenHigh: "/images/meshGradients/Pos=Right,Size=High,Colour=Pink-Purple-Green.svg",
  RedGreenTealHigh: "/images/meshGradients/Pos=Right,Size=High,Colour=Red-Green-Teal.svg",
  BlueGreenTealLow: "/images/meshGradients/Pos=Right,Size=Low,Colour=Blue-Green-Teal.svg",
  TealGreenLow: "/images/meshGradients/Pos=Right,Size=Low,Colour=Teal-Green.svg",
  OrangePinkLow: "/images/meshGradients/Pos=Right,Size=Low,Colour=Orange-Pink.svg",
  PinkBlueTealLow: "/images/meshGradients/Pos=Right,Size=Low,Colour=Pink-Blue-Teal.svg",
  PinkPurpleGreenLow: "/images/meshGradients/Pos=Right,Size=Low,Colour=Pink-Purple-Green.svg",
  RedGreenTealLow: "/images/meshGradients/Pos=Right,Size=Low,Colour=Red-Green-Teal.svg",
  LightGoldLow: "/images/meshGradients/Size=Low,Colour=Light-Gold.svg",
  StrongGoldLow: "/images/meshGradients/Size=Low,Colour=Strong-Gold.svg",
}